<!-- Sidebar principal -->
<div class="sidebar">
  <a href="javascript:void(0)" class="brand-link">

    <div class="logo-container">
      <img [src]="logo" alt="LOGO" class="logo-img" />
    </div>
    <!-- <div class="col-2 brand-text p-0 pr-3">
          <button (click)="ocultarMenu()" type="button"
              class="btn btn-xs btn-outline-info btn-inf btn-flat pl-1 pt-0 pb-0 pr-1">
              <span class="fa fa-times m-1"></span>
          </button>
      </div>  -->

  </a>
  <!-- Contenido con scroll -->
  <nav class="sidebar-content mt-2">
    <!-- Sidebar user (optional) -->
    <div class="user-panel mt-3 pb-3 mb-3 d-flex flex-column align-items-center text-center">
      <div class="image mb-2">
        <pf-image [src]="photo || 'assets/img/default-profile.png'" class="img-circle" alt="User Image" width="40"
          height="40" rounded>
        </pf-image>
      </div>
      <div class="info">
        <a class="d-block">
          {{ sesion.nombre + (sesion.apellidoPaterno ? ' ' + sesion.apellidoPaterno : '') +
          (sesion.apellidoMaterno ? ' ' + sesion.apellidoMaterno : '') }}
        </a>
      </div>
    </div>




    <!-- <div class="form-inline">
          <app-sidebar-search></app-sidebar-search>
      </div> -->

    <!-- Sidebar Menu -->
    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
      <li class="nav-item small">
        <a href="javascript:void(0)" [routerLinkActive]="'active'" class="nav-link">
          <p class="text-info">
            <mat-slide-toggle (change)="changeOcultarMenu()" [(ngModel)]="autoOcultarMenu" color="primary">
              Auto-ocultar Menu
            </mat-slide-toggle>
          </p>
        </a>
      </li>

      <app-menu-item *ngFor="let item of menu" [menuItem]="item"></app-menu-item>
    </ul>
  </nav>

  <!-- Footer con logo Sapi -->
  <div class="sidebar-footer">
    <img src="assets/img/sapi.png" alt="Logo Footer" />
  </div>
</div>